import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { apiClient } from '../utils/api';

export interface Persona {
  id: number;
  nc: string;
  denominacion: string;
  [key: string]: unknown;
}

export const usePersonas = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  const [personas, setPersonas] = useState<Persona[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const cargarPersonas = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const id_empresa = user?.id_empresa;
        if (!id_empresa) {
          setError('No se encontró el id_empresa en el usuario');
          return;
        }

        const token = await getAccessTokenSilently();
        const response = await apiClient.get<Persona[]>(
          `${process.env.REACT_APP_PADRON_URL}/leer_padron/${id_empresa}/`,
          { token }
        );
        
        setPersonas(response.data);
      } catch (err) {
        console.error('Error al cargar personas:', err);
        setError('Error al cargar el padrón');
      } finally {
        setLoading(false);
      }
    };

    if (user) {
      cargarPersonas();
    }
  }, [getAccessTokenSilently, user]);

  return { personas, loading, error };
};

